import React, { useContext, useState } from 'react';
import { ProfileSliderContext } from '../../appContext';

function OverlayBlock({ children }) {
  const {slider} = useContext(ProfileSliderContext);

  return (
    <div
      className={`absolute top-0 left-0 z-40 bg-white col-span-2 p-6  min-h-screen  w-full  transition-transform ease-linear duration-500 lg:translate-x-0 lg:w-auto lg:border-l-2 border-gray-300 lg:static lg:p-5 lg:z-0 ${
        slider ? 'translate-x-0' : 'translate-x-[1300px] duration-500'
      } md:pb-6 lg:pt-[0px]`}
    >
      {children}
    </div>
  );
}

export default OverlayBlock;
